import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import ArrayList from '../../../../../java/util/ArrayList';
var GeometryCombiner = /*#__PURE__*/function () {
  function GeometryCombiner() {
    _classCallCheck(this, GeometryCombiner);
    GeometryCombiner.constructor_.apply(this, arguments);
  }
  _createClass(GeometryCombiner, [{
    key: "extractElements",
    value: function extractElements(geom, elems) {
      if (geom === null) return null;
      for (var i = 0; i < geom.getNumGeometries(); i++) {
        var elemGeom = geom.getGeometryN(i);
        if (this._skipEmpty && elemGeom.isEmpty()) continue;
        elems.add(elemGeom);
      }
    }
  }, {
    key: "combine",
    value: function combine() {
      var elems = new ArrayList();
      for (var i = this._inputGeoms.iterator(); i.hasNext();) {
        var g = i.next();
        this.extractElements(g, elems);
      }
      if (elems.size() === 0) {
        if (this._geomFactory !== null) return this._geomFactory.createGeometryCollection();
        return null;
      }
      return this._geomFactory.buildGeometry(elems);
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      this._geomFactory = null;
      this._skipEmpty = false;
      this._inputGeoms = null;
      var geoms = arguments[0];
      this._geomFactory = GeometryCombiner.extractFactory(geoms);
      this._inputGeoms = geoms;
    }
  }, {
    key: "combine",
    value: function combine() {
      if (arguments.length === 1) {
        var geoms = arguments[0];
        var combiner = new GeometryCombiner(geoms);
        return combiner.combine();
      } else if (arguments.length === 2) {
        var g0 = arguments[0],
          g1 = arguments[1];
        var _combiner = new GeometryCombiner(GeometryCombiner.createList(g0, g1));
        return _combiner.combine();
      } else if (arguments.length === 3) {
        var _g = arguments[0],
          _g2 = arguments[1],
          g2 = arguments[2];
        var _combiner2 = new GeometryCombiner(GeometryCombiner.createList(_g, _g2, g2));
        return _combiner2.combine();
      }
    }
  }, {
    key: "extractFactory",
    value: function extractFactory(geoms) {
      if (geoms.isEmpty()) return null;
      return geoms.iterator().next().getFactory();
    }
  }, {
    key: "createList",
    value: function createList() {
      if (arguments.length === 2) {
        var obj0 = arguments[0],
          obj1 = arguments[1];
        var list = new ArrayList();
        list.add(obj0);
        list.add(obj1);
        return list;
      } else if (arguments.length === 3) {
        var _obj = arguments[0],
          _obj2 = arguments[1],
          obj2 = arguments[2];
        var _list = new ArrayList();
        _list.add(_obj);
        _list.add(_obj2);
        _list.add(obj2);
        return _list;
      }
    }
  }]);
  return GeometryCombiner;
}();
export { GeometryCombiner as default };